export const dbFields =
{
    id: {
        visiable: false,
        title: 'Role',
        key: 'id'
    },
    name: {
        visiable: false,
        title: 'Name',
        key: 'name'
    },
    desc: {
        visiable: false,
        title: 'Desc',
        key: 'desc'
    },
};
